export default "__VITE_ASSET__8Bz0YfqA__"